import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'

const TwFirstUnreadWrapper = tw.div`
  py-4
  px-24
`

const TwFirstUnread = tw.div`
  relative
  isolate
  h-20
  flex
  items-center
  justify-center
`

// Background as a separate element w/ opacity because `bg-grey-l100/50` doesn't work
const TwBackground = tw.div`
  -z-10
  absolute
  top-0
  right-0
  bottom-0
  left-0
  rounded-4
  bg-grey-l100
  opacity-[0.5]
`

const TwText = tw.div`
  flex-initial
  h-fit
  text-center
  text-secondary
  micro-semibold
`

interface Props {
  timestamp: number
}

export const FirstUnread = ({timestamp}: Props) => (
  <TwFirstUnreadWrapper>
    <TwFirstUnread id={`chat-unread-${timestamp}`}>
      <TwBackground />
      <TwText>{Lang.msg.unreadMessages}</TwText>
    </TwFirstUnread>
  </TwFirstUnreadWrapper>
)
